import React, { FC } from 'react';
import { BulkCreateGeneralInfoProps } from './BulkCreateGeneralInfoProps';
import Box from '@mui/material/Box';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { returnColumns } from './utils';
import useTranslation from '../../hooks/useTranslation';
import skapaColours from '@ingka/variables/colours-css';
import { useDispatch } from 'react-redux';
import { changeBuForBulkCreateProject } from '../../store/projects/actionWrapper';
import { SiteLocationType } from '../../store/projects/types';

const BulkCreateGeneralInfo: FC<BulkCreateGeneralInfoProps> = ({
  apiRef,
  projects,
  onChange,
  copyHandler,
  BUS,
  columnVisibility,
  countryList,
  deleteHandler,
  userOptions,
  onAddSolutionClickedHandler,
}) => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const countriesOptions = countryList.reduce((acc, country) => {
    return { ...acc, [country.countryId]: country.countryName };
  }, {});

  const onBuChange = (id, selectedBu) => {
    dispatch(
      changeBuForBulkCreateProject({
        bu: selectedBu,
        onSuccess: (siteLocation: SiteLocationType) => {
          onChange(id, 'siteLocation', {
            ...siteLocation,
            businessUnitId: selectedBu,
          });
        },
      }),
    );
  };

  const columns = returnColumns(
    onChange,
    onBuChange,
    t,
    copyHandler,
    deleteHandler,
    BUS,
    countriesOptions,
    userOptions,
    onAddSolutionClickedHandler,
  );
  return (
    <Box position="relative">
      <Box sx={{ height: '70vh' }} data-testid="ppm-project-bulk">
        <DataGridPremium
          rowHeight={64}
          apiRef={apiRef}
          sx={{
            border: 0,
            '.Mui-DatagridRow-even': {
              backgroundColor: skapaColours.colourNeutral2,
            },
            '.MuiDataGrid-columnHeaderTitle': {
              color: skapaColours.colourNeutral6,
            },
            '.overlow-auto': {
              overflow: 'visible',
              display: 'flex',
              alignItems: 'center',
            },
            '.overflow-visible': {
              overflow: 'visible !important',
            },
            '& [class*="__menu"]': {
              backgroundColor: '#fff',
              zIndex: 4,
            },
            '.select': {
              width: '100%',
            },
            '.bulk-table-error': {
              color: `${skapaColours.colourCommercialMessageBtiRed} !important`,
              '& .select__border ,.validation-border': {
                border: `1px solid ${skapaColours.colourCommercialMessageBtiRed}`,
              },
            },
            '.tooltip__custom-trigger-wrapper': {
              display: 'flex',
            },
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? 'Mui-DatagridRow-even'
              : 'Mui-DatagridRow-odd'
          }
          disableColumnMenu
          columnVisibilityModel={columnVisibility}
          disableRowSelectionOnClick
          isRowSelectable={() => false}
          onCellKeyDown={(params, event: React.KeyboardEvent) => {
            if (event.key === ' ') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              event.defaultMuiPrevented = true;
            }
            if (event.ctrlKey && event.key === 'a') {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              event.defaultMuiPrevented = true;
            }
          }}
          columns={columns as GridColDef[]}
          rows={projects}
        />
      </Box>
    </Box>
  );
};

export default BulkCreateGeneralInfo;
